async function devtricker_ajax_deleteAccount(password) {
    try {
        const formData = new FormData();
        formData.append('action', 'devtricker_verify_and_delete_account');
        formData.append('nonce', await devtricker_process_getDevtrickerNonce());
        formData.append('password', password);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, 'Account deleted successfully');
            return true;
        } else {
            throw new Error(result.data);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}
